import React from 'react'
import ReactDOM from 'react-dom/client'

import './i18n/i18n' // Initialize i18n

import App from './App'
import reportWebVitals from './reportWebVitals'

import './index.css'

// Ensure the root element exists
if (!document.getElementById('root')) {
  const rootElement = document.createElement('div')
  rootElement.id = 'root'
  document.body.appendChild(rootElement)
}

// Create the root and render the App component

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
